/*
 * Плагины, которые используются на всех страницах.
 *
 */
import BootstrapPlugin from './bootstrap';
import { VueConstructor } from 'vue/types/umd';

const plugin = {
    install(Vue : VueConstructor<Vue>) {
        BootstrapPlugin.install(Vue);
    }
};

/**
 * Общие плагины приложения
 */
export default plugin;
